<template>
    <div class="spacer-block">
        <hr
            v-if="withLine"
            class="spacer-line"
        />

        <div
            :class="classSpacer"
            class="spacer"
        ></div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    size: 'EXTRA_LARGE' | 'LARGE' | 'MEDIUM' | 'SMALL'
    withLine?: boolean
}>()

const classSpacer = computed(() =>
    props.size.toLocaleLowerCase().replace('_', '-')
)
</script>

<style lang="scss" scoped>
.spacer-block {
    width: 100%;
    display: block;
}

.spacer-line {
    border: none;
    border-bottom: $border-grey;
    margin: 0;
}

.spacer {
    width: 100%;
    display: block;

    &.small {
        height: 20px;
    }

    &.medium {
        height: 40px;
    }

    &.large {
        height: 60px;
    }

    &.extra-large {
        height: 80px;
    }
}
</style>
